import { FC } from 'react';

import { clsx } from 'clsx';

import { ProductCardBadges } from './ProductCardBadges';
import { CartonProduct, OverviewProduct } from '../../types';
import { Badge } from '../ui/Badge';
import { Card, CardContent } from '../ui/Card';
import { Image } from '../ui/Image';
import { Skeleton } from '../ui/Skeleton';

interface Props {
    product: CartonProduct | OverviewProduct;
    price?: number;
    loading: boolean;
    eagerLoadImage: boolean;
    amount?: number;
}

export const ProfileProductCard: FC<Props> = ({
    product,
    price,
    loading,
    eagerLoadImage,
    amount,
}) => (
    <Card
        className={clsx(
            'relative overflow-hidden rounded-2xl transition-all sm:group-hover:scale-105 sm:group-focus:scale-105 sm:hover:shadow-lg sm:focus:shadow-lg',
        )}
    >
        <div className={clsx('h-full w-full', { 'opacity-0': loading })}>
            <div className="relative aspect-[3/4]">
                <Image
                    src={product.image}
                    alt={product.image_alt}
                    className="h-full w-full object-fill"
                    loading={eagerLoadImage ? 'eager' : 'lazy'}
                />

                {!product.inStock && (
                    <div className="absolute inset-0 flex items-center justify-center bg-background/80">
                        <Badge
                            variant="destructive"
                            className="text-xs sm:text-sm"
                        >
                            Немає в наявності
                        </Badge>
                    </div>
                )}
            </div>
            <CardContent className="p-2 sm:p-3">
                <div className="flex h-26 flex-col">
                    <h3 className="line-clamp-2 text-sm font-medium sm:text-sm">
                        {product.name}
                    </h3>
                    <div className="mt-auto flex flex-col gap-1">
                        {typeof amount === 'number' && (
                            <ProductCardBadges product={product} />
                        )}
                        <div className="flex items-end justify-between">
                            <div className="flex items-end">
                                {typeof amount === 'number' && (
                                    <div>
                                        <Badge
                                            variant="outline"
                                            className="text-xs"
                                        >
                                            Кількість: {amount}
                                        </Badge>
                                    </div>
                                )}
                            </div>
                            {(price || product.min_price) && (
                                <Badge variant="outline" className="text-xs">
                                    ₴{price || product.min_price}
                                </Badge>
                            )}
                        </div>
                    </div>
                </div>
            </CardContent>
        </div>
        {loading && (
            <Skeleton
                className={
                    'pointer-events-none absolute top-0 left-0 h-full w-full'
                }
            />
        )}
    </Card>
);
